module.exports = __webpack_public_path__ + "static/media/labeling.9c34727c.svg";